<template>
  <b-modal
    id="validation-modal"
    :size="'sm'"
    :visible="validationModalConfig.isOpen"
    hide-header-close
    hide-header
    centered
    @hidden="closeValidationModal(validationModalConfig.onClose)"
  >
    <b-row class="d-flex h-100 align-items-center text-center validation-body">
      <b-col
        v-if="validationModalConfig.title && validationModalConfig.description"
        cols="12"
      >
        <div
          class="validation-title"
          :class="[
             validationModalConfig.type == 'warning' ? 'warning-title': null ,
             validationModalConfig.titleClass ? validationModalConfig.titleClass : null,
          ]"
          v-safe-html="validationModalConfig.title"
        >
          <!-- {{ validationModalConfig.title }} -->
        </div>
        <div
          class="validation-description"
          :class="
            validationModalConfig.type == 'warning'
              ? 'warning-description'
              : null
          "
          v-safe-html="validationModalConfig.description"
        >
          <!-- {{ validationModalConfig.description }} -->
        </div>
      </b-col>
      <b-col
        v-if="validationModalConfig.title && !validationModalConfig.description"
        cols="12"
      >
        <div
          class="validation-title validation-title-no-description"
          :class="[
             validationModalConfig.type == 'warning' ? 'warning-title': null ,
             validationModalConfig.titleClass ? validationModalConfig.titleClass : null,
          ]"
          v-safe-html="validationModalConfig.title"
        >
          <!-- {{ validationModalConfig.title }} -->
        </div>
      </b-col>

      <b-col
        v-if="!validationModalConfig.title && validationModalConfig.description"
        cols="12"
      >
        <div
          class="validation-title"
          :class="
            validationModalConfig.type == 'warning' ? 'warning-title' : null
          "
        >
          {{
            validationModalConfig.type == 'warning'
              ? 'คำเตือน !'
              : validationModalConfig.type == 'success'
                ? 'ทำรายการสำเร็จ !'
                : 'เกิดข้อผิดพลาด !'
          }}
        </div>
        <div
          class="validation-description"
          :class="
            validationModalConfig.type == 'warning'
              ? 'warning-description'
              : null
          "
          v-safe-html="validationModalConfig.description"
        >
          <!-- {{ validationModalConfig.description }} -->
        </div>
      </b-col>

      <b-col
        v-if="
          !validationModalConfig.title && !validationModalConfig.description
        "
        cols="12"
      >
        <div
          class="validation-title-no-description"
          :class="
            validationModalConfig.type == 'warning' ? 'warning-title' : null
          "
        >
          {{
            validationModalConfig.type == 'warning'
              ? 'คำเตือน !'
              : validationModalConfig.type == 'success'
                ? 'ทำรายการสำเร็จ !'
                : 'เกิดข้อผิดพลาด !'
          }}
        </div>
      </b-col>
    </b-row>

    <template #modal-footer>
      <div
        v-if="validationModalConfig.type == 'warning'"
        class="d-flex justify-content-center w-100 warning-footer"
      >
        <b-button
          v-if="!validationModalConfig.cancelBtn_Disabled"
          class="w-100 validation-button-cancel"
          @click="validationModalConfig.onCancel"
        >
          <span class="validation-button-text-cancel">ปิด</span>
        </b-button>
        <b-button
          v-if="!validationModalConfig.confirmBtn_Disabled"
          variant="success"
          class="w-100"
          :class="[
            validationModalConfig.cancelBtn_Disabled
              ? 'warning-button-confirm-re'
              : 'warning-button-confirm',
          ]"
          @click="validationModalConfig.onConfirm"
        >
          <span class="validation-button-text">{{
            validationModalConfig.confirmLabel || 'ยืนยัน'
          }}</span>
        </b-button>
      </div>
      <div
        v-if="validationModalConfig.type == 'success'"
        class="m-0"
      >
        <b-button
          variant="success"
          class="w-100 confirm-button"
          @click="validationModalConfig.onConfirm"
        >
          <span>{{ validationModalConfig.confirmLabel || 'ตกลง' }}</span>
        </b-button>
      </div>
      <div
        v-if="
          validationModalConfig.type == 'error' ||
            validationModalConfig.type == 'form-error'
        "
        class="m-0"
        :class="
          validationModalConfig.type == 'error'
            ? 'confirm-error-button'
            : 'confirm-form-error-button'
        "
      >
        <b-button
          class="w-100"
          @click="validationModalConfig.onConfirm"
        >
          <span>{{ validationModalConfig.confirmLabel || 'ตกลง' }}</span>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BRow, BCol, BButton,
} from 'bootstrap-vue'

import { computed } from '@vue/composition-api'
import store from '@/store'
import useValidationModal from './hooks/useValidationModal'

export default {
  components: {
    BModal,
    BRow,
    BCol,
    BButton,
  },

  setup() {
    const { closeValidationModal, resolveIcon } = useValidationModal()

    const validationModalConfig = computed(() => {
      const config = store.getters['baseComponent/validationModalConfig']
      resolveIcon(config.type)

      return config
    })

    return {
      validationModalConfig,
      closeValidationModal,
    }
  },
}
</script>

<style></style>

<style scoped>
  @import '~@/assets/css/override-styles/validation-modal.css';
</style>
